// Handheld SAR direction finder (M36.2, SAR-4): a horizontal bar of SAR_DF_LEDS
// LEDs — the centre LED lights when the beacon is dead ahead, the left/right LEDs
// when it is off to that side, all dark when there is no signal. The trainee homes
// by turning until the centre LED is lit. Client-only (ENG-1); the sim owns the
// bearing → LED-index math (sim/education/sar.ts `ledIndex`).
import { h } from '../h';
import { SAR } from '../../../sim/config';

export class SarDfHud {
  readonly el: HTMLElement;
  private readonly leds: HTMLElement[] = [];
  private shown = false;

  constructor() {
    const mid = (SAR.DF_LEDS - 1) / 2;
    for (let i = 0; i < SAR.DF_LEDS; i++) {
      this.leds.push(h('div', { class: 'bb-df-led', 'data-testid': `sar-led-${i}`, 'data-center': i === mid ? '1' : '0', style: {
        width: '16px', height: '16px', borderRadius: '50%', background: '#20303a',
        border: i === mid ? '2px solid #6a8' : '1px solid #345', boxSizing: 'border-box',
      } }));
    }
    this.el = h('div', { class: 'bb-df', 'data-testid': 'sar-df', style: {
      position: 'absolute', left: '50%', bottom: '64px', transform: 'translateX(-50%)',
      display: 'none', gap: '6px', padding: '6px 10px', alignItems: 'center',
      background: 'rgba(10,16,28,0.55)', borderRadius: '8px', pointerEvents: 'none',
    } }, ...this.leds);
  }

  setVisible(v: boolean): void { this.shown = v; this.el.style.display = v ? 'flex' : 'none'; }
  get visible(): boolean { return this.shown; }

  /** Light the LED at `idx` (from `ledIndex`), or all dark when idx is null. */
  update(idx: number | null): void {
    if (!this.shown) return;
    const mid = (SAR.DF_LEDS - 1) / 2;
    for (let i = 0; i < this.leds.length; i++) {
      const lit = idx !== null && i === idx;
      const led = this.leds[i]!;
      led.style.background = lit ? (i === mid ? '#37d67a' : '#e8c14a') : '#20303a';
      led.style.boxShadow = lit ? `0 0 8px ${i === mid ? '#37d67a' : '#e8c14a'}` : 'none';
      led.classList.toggle('bb-df-lit', lit);
    }
  }
}
